export default {
    meta: {
        title: '拓店宝-确定店铺信息选择场地'
    }
};
